// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DIj5","question":"styles_question__dM-e4","description":"styles_description__1ielb"};